/* global I18n */

import {Controller} from "@hotwired/stimulus"
import {getUserLocales} from "get-user-locale"
import user_settings from "user_settings"

class LanguageSelectionController extends Controller {
  static targets = ["headline", "button"]

  connect() {
    if (I18n.locale !== "en") return
    if (user_settings.get("language_selected")) return

    this.locale = this.get_alternative_locale()
    if (!this.locale || this.locale === I18n.locale) return

    this.open()
  }

  get_alternative_locale() {
    const browser_locales =
      getUserLocales().map((locale) => locale.split("-")[0])
    return browser_locales.filter(v =>
      window.gon.available_locales.includes(v)
    )[0]
  }

  open() {
    this.headlineTarget.innerHTML =
      I18n.t("js.language_selection_cta.message", {locale: this.locale})
    this.buttonTarget.innerHTML =
      I18n.t("js.language_selection_cta.cta", {locale: this.locale})
    this.element.classList.remove("hide")
  }

  close() {
    user_settings.register({language_selected: true})
    this.element.remove()
  }

  change_language() {
    this.close()
    window.location = `/${this.locale}`
  }
}

export default LanguageSelectionController
